<div class="default-theme">
  <mat-sidenav-container class="main-container">
    <!--<mat-sidenav #sidenav mode="side" [opened]="sidenavOpened" class="navigation-bar">
      <div fxFlex fxLayout="column" fxLayoutAlign="space-between" class="navigation-bar-content">
        <mat-nav-list class="sidenav">
          <section>
            <a mat-list-item [routerLink]="['/home']" [routerLinkActive]="'active-link'" class="item-container">
              <svg class="item-icon sidenav-device" [attr.fill]="'white'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="white" /></svg>
              <p translate>TAB_NAV.HOME</p>
            </a>
          </section>
          <header fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px" class="fw-600">
            <hr fxFlex class="regular-1px-line"/>
          </header>
          <section>
            <a mat-list-item [routerLink]="['/device']" [routerLinkActive]="'active-link'" class="item-container">
              <svg class="item-icon sidenav-device" [attr.fill]="'white'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"/></svg>
              <p translate>TAB_NAV.DEVICES</p>
            </a>
          </section>
        </mat-nav-list>

        <div fxLayoutAlign="center center" class="sticky">
          <span class="version">{{appVersion}}</span>
        </div>
      </div>
    </mat-sidenav>-->

    <mat-sidenav #sidenav mode="side" [opened]="sidenavOpened" class="navigation-bar">
      <div fxFlex fxLayout="column" fxLayoutAlign="space-between" class="navigation-bar-content">

        <mat-nav-list class="sidenav">
        </mat-nav-list>

        <div fxLayoutAlign="center center" class="sticky">
          <span class="version">v-{{appVersion}}</span>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="sticky">
        <header fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="20px">
          <!--<button
            mat-icon-button
            class="regular-round-button"
            [matTooltip]="'HEADER.TOGGLE_NAVIGATION_TOOLTIP' | translate"
            [matTooltipClass]="'regular-tooltip'"
            (click)="toggleSideNav()">
            <mat-icon>menu</mat-icon>
          </button>-->

          <img src="assets/images/logo-air-liquide.svg" (click)="goHome()" alt="" />

          <span class="border-left" translate>TAB_NAV.HOME</span>

          <span class="border-left">{{ businessProfile?.entityName }}</span>

          <span fxFlex></span>

          <span class="border-right">{{ businessProfile?.timezoneDetails?.name }} {{ businessProfile?.timezoneDetails?.offset }}</span>

          <span class="border-right">{{ businessProfile.name }}</span>

          <!--<mat-select *ngIf="businessProfile" class="navbar-business-profile-select border-right" [value]="businessProfile" (selectionChange)="switchBusinessProfile($event)">
            <mat-option *ngFor="let profile of businessProfiles" [value]="profile">
              {{ profile.name }}
            </mat-option>
          </mat-select>-->

          <button mat-mini-fab [matMenuTriggerFor]="menu" class="user-button" color="accent">{{ initials }}</button>
          <mat-menu #menu="matMenu" fxLayout="row">
            <button mat-menu-item (click)="onLogout()">{{ 'HEADER.LOGOUT' | translate }}</button>
          </mat-menu>
        </header>
      </div>

      <app-devices [deviceName]="deviceName" [deviceIdentifier]="deviceIdentifier"></app-devices>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

